import React, { ChangeEvent, useState, useEffect } from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import { authUser } from '../../services/AuthService'
import Input from '../../components/Form/Input';
import PublicBackground from '../../components/PublicBackground';
import Alert from '../../helpers/Alert';

import "./index.css"


interface TypeData {
  email: string;
  senha: string;
}

export default function LoginPage() {
  let history = useNavigate();

  const [data, setData] = useState<TypeData>({ email: '', senha: '' });

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setData({ ...data, [name]: value });
  };

  const handleSubmit = (event: ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();

    authUser(data.email, data.senha)
      .then((res) => history('/Home'))
      .catch((err) => Alert(false, 'Não foi possível realizar o login'));
  }


  return (
    <PublicBackground>
      <div className="login-title">Acesse Sua conta</div>
      <div className="login--form-container">
        <Form onSubmit={handleSubmit} className="login-form">
          <Input
            className="login-input"
            name="email"
            label="E-mail"
            type="email"
            placeholder={'Digite seu email'}
            data={data.email}
            setData={handleInputChange}
            required={true}
          />
          <Input
            className="login-input"
            name="senha"
            label="Senha"
            type="password"
            placeholder={'Digite sua senha'}
            data={data.senha}
            setData={handleInputChange}
            required={true}
          />
          <div className="l-inline-end">
            <NavLink to='/recuperar'>
              <span className="login-forget">Esqueci minha senha</span>
            </NavLink>
          </div>

          {/* <Form.Group controlId="formBasicCheckbox" className="mt-3">
              <Form.Check type="checkbox" label="Lembrar senha"></Form.Check>
            </Form.Group> */}

          <button className='login-button' type="submit">Entrar</button>
          <div className="login-signup--wrapper">
            <NavLink to='/cadastro'>
              <span className="login-signup">Não tenho conta</span>
            </NavLink>
          </div>
        </Form>
      </div>
    </PublicBackground>

  )
}
